import _regeneratorRuntime from "/home/jonsun/spot-frontend/node_modules/@babel/runtime/regenerator";

var _this = this;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

import isAbsoluteUrl from 'axios/lib/helpers/isAbsoluteURL';
var responseTypes = ['arraybuffer', 'blob', 'formData', 'json', 'text', null];

var getResponseData = function getResponseData(response, responseType) {
  if (responseTypes.indexOf(responseType) === -1) {
    throw new Error("responseType must be one of the following: 'arraybuffer', 'blob', 'formData', 'json', 'text', null");
  }

  if (responseType === null) {
    return Promise.resolve(null);
  }

  return response[responseType]();
};

var prepareSuccessPayload = function prepareSuccessPayload(response) {
  return response.data;
};

var DummyAbortController = function () {
  function DummyAbortController() {
    _classCallCheck(this, DummyAbortController);
  }

  _createClass(DummyAbortController, [{
    key: 'abort',

    /* eslint-disable-next-line class-methods-use-this */
    value: function abort() {}
  }]);

  return DummyAbortController;
}();

var createDriver = function createDriver(fetchInstance) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$baseURL = _ref.baseURL,
      baseURL = _ref$baseURL === undefined ? '' : _ref$baseURL,
      _ref$AbortController = _ref.AbortController,
      AbortController = _ref$AbortController === undefined ? DummyAbortController : _ref$AbortController;

  return {
    requestInstance: fetchInstance,
    getAbortSource: function getAbortSource() {
      return new AbortController();
    },
    abortRequest: function abortRequest(abortSource) {
      abortSource.abort();
    },
    sendRequest: function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(_ref3, abortSource) {
        var url = _ref3.url,
            _ref3$responseType = _ref3.responseType,
            responseType = _ref3$responseType === undefined ? 'json' : _ref3$responseType,
            requestConfig = _objectWithoutProperties(_ref3, ['url', 'responseType']);

        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetchInstance(isAbsoluteUrl(url) ? url : baseURL + url, _extends({
                  signal: abortSource.signal
                }, requestConfig));

              case 2:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 4;
                _context.next = 7;
                return response.json();

              case 7:
                response.data = _context.sent;
                _context.next = 12;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

              case 12:
                throw response;

              case 13:
                _context.next = 15;
                return getResponseData(response, responseType);

              case 15:
                response.data = _context.sent;
                return _context.abrupt('return', response);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 10]]);
      }));

      return function sendRequest(_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }(),
    getSuccessPayload: function getSuccessPayload(response) {
      if (Array.isArray(response)) {
        return response.map(prepareSuccessPayload);
      }

      return prepareSuccessPayload(response);
    },
    getErrorPayload: function getErrorPayload(error) {
      return error;
    }
  };
};

export { createDriver };